/*
 * Renews an expired sign-in when the reader moves to another page inside the
 * public site (2026-10-15, the owner: "Moving between pages inside the site should
 * also trigger a renewal.").
 *
 * A page load already renews (AuthProvider, acquireTokenOnPublicPage); this covers
 * the client-side moves after it, through AuthState.renewExpiredSignIn. Keyed on
 * the PATH, not the whole address: the search box writes its words into the
 * address as the reader types, and a renewal must not take the page from under a
 * half-typed search. So opening an article or a note renews; searching and paging
 * within a list do not.
 *
 * It also runs once when the public shell mounts: on a page load that is a no-op,
 * MSAL not being ready yet, and on the way in from the admin site it is the move.
 * The admin site needs none of this - every admin page calls the admin API, whose
 * token provider renews (acquireToken).
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider.js';

export function useRenewOnNavigation(): void {
  const { pathname } = useLocation();
  const { renewExpiredSignIn } = useAuth();

  // The latest function, without a new one being a reason to renew: it changes
  // once MSAL is ready, and the page load's own check renews then.
  const renew = useRef(renewExpiredSignIn);
  useEffect(() => {
    renew.current = renewExpiredSignIn;
  }, [renewExpiredSignIn]);

  useEffect(() => {
    renew.current();
  }, [pathname]);
}
